export const PAGE_NAME = {
  TRADEIN_VEHICLE_SELECTOR: 'TRADEIN_VEHICLE_SELECTOR',
  VEHICLE_SELECTOR: 'VEHICLE_SELECTOR',
  DEALER_SELECTOR: 'DEALER_SELECTOR',
  CONTACT_FORM: 'CONTACT_FORM',
  THANK_YOU_PAGE: 'THANK_YOU_PAGE',
};

export const HOST_WEBSITES = {
  KBB: 'kbb',
  ATC: 'atc'
};

export const VEHICLE_LISTING_TYPE = {
  NEW: 'new',
  USED: 'used',
  CPO: 'cpo',
  TRADEIN: 'tradein',
};

export const DROPDOWN_TYPE = {
  YEAR: 'year',
  MAKE: 'make',
  MODEL: 'model',
  TRIM: 'trim',
};

export const RESPONSE_TYPE = {
  SUBMIT_LEAD_SUCCESS: 'SUBMIT_LEAD_SUCCESS'
};

export const HEADER_TEXT_VALUES = {
  BLANK_HEADER: 'Free Dealer Price Quote',
};

export const FLOODLIGHT_KEYS = {
  YEAR: 'FLOODLIGHT_YEAR',
  MAKE: 'FLOODLIGHT_MAKE',
  MODEL: 'FLOODLIGHT_MODEL',
  TRIM: 'FLOODLIGHT_TRIM',
  SEND_TO: 'send_to',
};